import APIStates from 'enum/APIStates';


const tippingStoreInitialState = {
  tokenBalance: 0,
  sendTipStatus: APIStates.INITIAL,
  tippingInfo: {},
  tippingInfoStatus: APIStates.INITIAL,
  performerSessionTippingInfo: { balance: 0 },
  performerSessionTippingInfoStatus: APIStates.INITIAL,
  sendTipResponseStatus: APIStates.INITIAL,
  anonymousTippingHash: '',
  totalTippedAmount: null,
  performerTopTipper: '',
  performerTopTipperAmount: null,
};

export default tippingStoreInitialState;
